<template>
    <div>
        <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="400px"
            @close="setDialogClosed" append-to-body>
            <el-container direction="vertical">
                <el-row>
                    <el-descriptions direction="vertical" :column="2">
                        <el-descriptions-item label="*年度血糖控制评估情况">
                            <el-tag size="mini" type="success">达标</el-tag>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-row>

                <el-row>
                    <el-descriptions direction="vertical" :column="2">
                        <el-descriptions-item label="*最近一次空腹血糖">
                            6.3
                            <el-tag size="mini" type="success">达标</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="*最近一次糖化血红蛋白">
                            6.2
                            <el-tag size="mini" type="success">达标</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="*最近一次血压">
                            153/80
                            <el-tag size="mini" type="danger">不达标</el-tag>
                        </el-descriptions-item>
                        <el-descriptions-item label="*最近一次血脂">
                            6.2
                            <el-tag size="mini" type="success">达标</el-tag>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-row>

                <el-row style="margin-top: 20px;">
                    <el-descriptions direction="vertical" :column="1">
                        <el-descriptions-item label="*危险因素">
                            <el-input type="textarea" :rows="2" :disabled="true" v-model="riskElement"></el-input>
                        </el-descriptions-item>
                        <el-descriptions-item label="并发症">
                            <el-input type="textarea" :rows="2" :disabled="true" v-model="riskElement">无</el-input>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-row>

                <el-row>
                    <div style="float: right; margin-bottom:10px;margin-top: 20px;">
                        <el-button size="small" type="primary" @click="onSubmit">生成新年度一体化管理方案</el-button>
                        <el-button size="small" @click="setDialogClosed">取消</el-button>
                    </div>
                </el-row>
            </el-container>
        </el-dialog>
    </div>
</template>

<script>
import moment from "moment";

export default {
    data() {
        return {
            showDialog: false,
            title: "年度综合评估结果",
            list: null,
            listLoading: false,
            riskElement:'无'
        };
    },
    methods: {
        // 编辑初始化页面内容
        async init(dataContext) {
            console.log(dataContext);
            this.showDialog = true;
            this.$nextTick(() => {
                this.getReportDetail(dataContext.id);
            });
        },
        // 关闭对话框触发
        setDialogClosed() {
            this.showDialog = false;
        },
        getParsedTime(time) {
            return moment(time).format("YYYY-MM-DD HH:mm");
        },
        getReportDetail(itemId) {

        },
        onSubmit() {

        }
    },
};
</script>

<style lang="less" scoped></style>